import { Block } from '@components/core-ui/Block';
import styled from 'styled-components';

export const StyledBlock = styled(Block)`
  .add-assignee {
    padding: 5px 0 10px;
    border: none;
    background: none;
    color: var(--color-link);
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    text-decoration-line: underline;

    &:hover {
      color: var(--color-text-muted);
    }
  }

  .assignee-wrapper {
    display: flex;
    gap: 10px;
    align-items: center;

    .assignee {
      text-overflow: ellipsis;
      overflow: hidden;

      .assignName {
        color: #b4b9d9;
        text-decoration: underline;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        margin: 0;
      }

      .assignEmail {
        color: #313131;
        font-style: normal;
        font-weight: 500;
        font-size: 10px;
        line-height: 100%;
        margin: 0;
      }
    }

    .edit-assignee {
      svg {
        width: 30px;
        height: 30px;
        cursor: pointer;
        color: var(--color-text-muted);

        :hover {
          color: var(--color-accent);
        }
      }
    }

    .remove-assignee {
      color: var(--color-text-muted);
      svg {
        width: 30px;
        height: 30px;
        cursor: pointer;
        padding: 5px;
        border-radius: 3px;
        color: #d5def2;

        :hover {
          background: var(--color-danger);
          color: var(--color-fixed-white);
        }
      }
    }
  }
`;
